import { useTranslation } from 'react-i18next';
import {
  appLocales,
  getActiveLocale,
  localeShortNames,
  setActiveLocale,
  type AppLocale,
} from '../i18n/i18n';

const labelKeys: Readonly<Record<AppLocale, string>> = {
  en: 'context.english',
  fa: 'context.persian',
  ar: 'context.arabic',
};

/** Native three-language selector shared by public, authentication and offline shells. */
export function LanguageSelect({ className = '' }: { readonly className?: string }) {
  const { t } = useTranslation();
  const locale = getActiveLocale();

  return (
    <select
      className={`language-switch language-switch--select ${className}`.trim()}
      value={locale}
      aria-label={t('context.language')}
      onChange={(event) => void setActiveLocale(event.target.value as AppLocale)}
    >
      {appLocales.map((choice) => (
        <option key={choice} value={choice} lang={choice} dir={choice === 'en' ? 'ltr' : 'rtl'}>
          {localeShortNames[choice]} · {t(labelKeys[choice])}
        </option>
      ))}
    </select>
  );
}
